<template>
    <div class="land-about">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.about}}</h2>
            </div>
            <div class="land-about-column-container">
                <div class="col-left">
                    <div class="desc-main" v-html="salesCard.project_land_site.about_desc"></div>
                    <div class="col-img col-img-mobile">
                        <img :src="salesCard.project_land_site.about_img" alt="">
                    </div>
                    <div class="desc-under" v-html="salesCard.project_land_site.about_desc_under"></div>
                </div>
                <div class="col-right">
                    <div class="col-img">
                        <img :src="salesCard.project_land_site.about_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-about',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-about.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-about-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>